import { programsPeopleEnrollment } from '@fireflyhealth/api'
import { useQuery } from '~/shared/hooks/query'

const listProgramEnrollments = async (personId: number) => {
  const { data } = await programsPeopleEnrollment.list({ person_id: personId })
  return data
}

export const listProgramEnrollmentsKey = 'listProgramEnrollments'

export const useListProgramEnrollments = (personId: number) =>
  useQuery(
    [listProgramEnrollmentsKey, personId],
    () => listProgramEnrollments(personId),
    { enabled: personId !== null },
    { error: 'Failed to fetch program enrollments' },
  )
